<template>
  <v-container>
        <h1 class="text-center ">
            Miscellaneous, Mortgage Tax and Special Amount
        </h1>
        <v-row dense align="center" justify="center">
            <v-col cols="4">
                <ClarionDateControl
                class="input-text-size"
                label="From Date"
                :isToggle="false"
                v-model="editedItem.fromDate"
                :isReadOnly="true"
                :isDisabled="true"
                />
            </v-col>
            <v-col cols="4">
                <ClarionDateControl
                class="input-text-size"
                label="To Date"
                :isToggle="false"
                v-model="editedItem.toDate"
                :isReadOnly="true"
                :isDisabled="true"
                />
            </v-col>
        </v-row>
        <v-row dense align="center" justify="center">
            <v-col cols="4" class="text-right">
                <v-text-field
                  dense
                  v-model="editedItem.totalMtgTax"
                  label="Mortgage Taxes"
                 >
                </v-text-field>
            </v-col>
            <v-col cols="4" class="text-right">
                <v-text-field
                dense
                readonly tabindex="-1"
                v-model="editedItem.totalCertFees"
                label="Mtg Tax Cert fees"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row dense align="start" justify="center">
            <v-col cols="6" class="text-right">
                <v-text-field
                dense
                readonly tabindex="-1"
                v-model="editedItem.totalMisc"
                label="Miscellaneous Receipts Total"
                >
                </v-text-field>
            </v-col>
        </v-row>
              <v-row dense>
                        <v-col cols="12" class="text-center mb-2">
                            <h4>Special Amounts</h4>
                        </v-col>
                        <v-col cols="12" class="text-center mb-2">
                <v-row justify="center" align="center" >
                <v-col cols="5" class="text-center">
                    <v-row dense>
                        <v-col cols="12" class="text-center mb-2">
                            <h4>Schools</h4>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="10" class="text-center">
                            <v-text-field
                            dense
                            readonly tabindex="-1"
                            v-model="editedItem.jointMill"
                            label="Joint 4-Mill"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="10" class="text-center">
                             <v-text-field
                             dense
                             readonly tabindex="-1"
                             v-model="editedItem.mvTaxStamps"
                             label="MVTS"
                             >
                             </v-text-field >
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="10" class="text-center">
                            <v-text-field
                            dense
                            readonly tabindex="-1"
                            v-model="editedItem.otherADA"
                            label="Other ADA"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>

                </v-col>
                <v-col cols="5" class="text-center">
                    <v-row dense class="mb-2">
                        <v-col cols="12" class="text-center">
                            <h4>Cities</h4>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="10" class="text-center">
                            <v-text-field
                            dense
                            readonly tabindex="-1"
                            v-model="editedItem.alcoholicBevTax"
                            label="Alcoholic Bev Tax"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="10" class="text-center">
                             <v-text-field
                             dense
                             readonly tabindex="-1"
                             v-model="editedItem.motorVechicle"
                             label="Motor Vehicle"
                             >
                             </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="10" class="text-center">
                             <v-text-field
                             dense
                             readonly tabindex="-1"
                             v-model="editedItem.otherCensus"
                             label="Other Census"
                             >
                             </v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
                </v-row>
                        </v-col>
                <v-col cols="12" class="text-center mt-4">
                <v-row justify="center" align="center" >
              <!-- <v-row dense > -->
                <v-col cols="6">
                  <v-text-field
                  dense
                  readonly tabindex="-1"
                  v-model="editedItem.apportionLikeTaxes"
                  label="Total Apportioned Like Taxes"
                  >
                  </v-text-field>
                </v-col>
              <!-- </v-row> -->
              <!-- <v-row dense> -->
                <v-col cols="6">
                  <v-text-field
                  dense
                  readonly tabindex="-1"
                  v-model="editedItem.totalofSpecialApportionment"
                  label="Total of Special Apportionments"
                  >
                  </v-text-field>
                </v-col>
              <!-- </v-row> -->
              </v-row>
                </v-col>
              </v-row>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { amountFormat, amountToNumber } from '../../../util/shared/vue-global';

export default {
  components: {
    ClarionDateControl,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('base/crud', ['item']),

    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  mounted() {
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    roundAmount() {
      this.editedItem.totalMtgTax = amountFormat(amountToNumber(this.editedItem.totalMtgTax));
      this.editedItem.totalCertFees = amountFormat(amountToNumber(this.editedItem.totalCertFees));
      this.editedItem.totalMisc = amountFormat(amountToNumber(this.editedItem.totalMisc));
      this.editedItem.jointMill = amountFormat(amountToNumber(this.editedItem.jointMill));
      this.editedItem.mvTaxStamps = amountFormat(amountToNumber(this.editedItem.mvTaxStamps));

      this.editedItem.otherADA = amountFormat(amountToNumber(this.editedItem.otherADA));

      this.editedItem.alcoholicBevTax = amountFormat(
        amountToNumber(this.editedItem.alcoholicBevTax),
      );
      this.editedItem.motorVechicle = amountFormat(amountToNumber(this.editedItem.motorVechicle));

      this.editedItem.otherCensus = amountFormat(amountToNumber(this.editedItem.otherCensus));
      this.editedItem.apportionLikeTaxes = amountFormat(
        amountToNumber(this.editedItem.apportionLikeTaxes),
      );

      this.editedItem.totalofSpecialApportionment = amountFormat(
        amountToNumber(this.editedItem.totalofSpecialApportionment),
      );
    },
  },
};
</script>

<style scoped>
.v-card {
  max-width: 600px;
  margin: 0 auto;
}
.border{
    border: 1px solid black;
    border-radius: 5px;
    margin: 3px;
    padding: 18px;
}

</style>
